import { Link } from "react-router-dom";

export default function Footer() {
  const currentYear = new Date().getFullYear();

  const footerColumns = [
    {
      title: "Stay with us",
      links: [
        { label: "Suites & Homes", href: "/stay" },
      ],
    },
    {
      title: "Know before you go",
      links: [
        { label: "FAQs", href: "/enquiry" },
        { label: "Host Desk", href: "mailto:hello@gawkari.in", external: true },
        {
          label: "Get Directions",
          href: "https://maps.google.com/?q=Gawkari+Agro+Retreat",
          external: true,
        },
        { label: "Request a callback", href: "tel:+919999999999", external: true },
      ],
    },
  ];

  const socialLinks = [
    {
      label: "Facebook",
      href: "https://www.facebook.com/profile.php?id=61583556767193",
      icon: (
        <svg width="24" height="24" viewBox="0 0 24 24" fill="currentColor">
          <path d="M22 12.06c0-5.52-4.48-10-10-10s-10 4.48-10 10c0 4.99 3.66 9.12 8.44 9.88v-6.99H8.13v-2.89h2.31V9.41c0-2.28 1.36-3.54 3.44-3.54.99 0 2.03.18 2.03.18v2.24h-1.14c-1.13 0-1.49.7-1.49 1.41v1.7h2.54l-.41 2.89h-2.13v6.99C18.34 21.18 22 17.05 22 12.06Z" />
        </svg>
      ),
    },
    {
      label: "Instagram",
      href: "https://www.instagram.com/gawkari_hillside/",
      icon: (
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8">
          <rect x="3" y="3" width="18" height="18" rx="4.5" />
          <circle cx="12" cy="12" r="3.8" />
          <circle cx="17.3" cy="6.7" r="0.9" fill="currentColor" stroke="none" />
        </svg>
      ),
    },
    {
      label: "X",
      href: "https://x.com/gawkari_hilside",
      icon: (
        <svg width="24" height="24" viewBox="0 0 24 24" fill="currentColor">
          <path d="M18.9 5.1h-2.3l-3.33 4.18-3.1-4.18H5.1l5.16 6.9-4.96 6.9h2.3l3.75-4.8 3.54 4.8h5.02l-5.3-7.14 5.29-6.66Z" />
        </svg>
      ),
    },
    {
      label: "YouTube",
      href: "https://www.youtube.com/@Gawkari",
      icon: (
        <svg width="24" height="24" viewBox="0 0 24 24" fill="currentColor">
          <path d="M21.5 8.3a2.5 2.5 0 0 0-1.76-1.77C18.17 6 12 6 12 6s-6.17 0-7.74.53A2.5 2.5 0 0 0 2.5 8.3 26.4 26.4 0 0 0 2 12c-.01 1.24.04 2.48.5 3.7a2.5 2.5 0 0 0 1.76 1.77C5.83 18 12 18 12 18s6.17 0 7.74-.53a2.5 2.5 0 0 0 1.76-1.77c.46-1.22.51-2.46.5-3.7.01-1.24-.04-2.48-.5-3.7ZM10.4 14.6V9.4l4.53 2.6-4.53 2.6Z" />
        </svg>
      ),
    },
  ];

  return (
    <>
      <img width="100%" src="https://res.cloudinary.com/dqlodrd4i/image/upload/v1763487110/Untitled_design_4_qodk9a.gif" alt="" />
      <footer id="footer" className="footer d-print-none text-white py-5" style={{ backgroundColor: '#7ed957', marginTop: '-2px' }}>
        <div className="container-xl">
          <div className="row g-4">
            <div className="col-12 col-md-4">
              <span className="h2 d-block mb-3 fw-bold text-white" style={{ fontFamily: ' "poppins","sans-serif' }}>Gawkari Hillside</span>
              <p className="mb-4 text-white-75">
                At satalewadi, post parkhandi,
                <br />
                satara, maharastra, 412803
              </p>
              <ul className="list-unstyled mb-4 d-flex flex-column gap-2">
                <li>
                  <a href="tel:+919284636553" className="text-white text-decoration-none d-flex align-items-center gap-2">
                    <svg xmlns="http://www.w3.org/2000/svg" className="icon icon-tabler icon-tabler-phone" width="20" height="20" viewBox="0 0 24 24" strokeWidth="2" stroke="currentColor" fill="none" strokeLinecap="round" strokeLinejoin="round"><path stroke="none" d="M0 0h24v24H0z" fill="none"/><path d="M5 4h4l2 5l-2.5 1.5a11 11 0 0 0 5 5l1.5 -2.5l5 2v4a2 2 0 0 1 -2 2a16 16 0 0 1 -15 -15a2 2 0 0 1 2 -2" /></svg>
                    +91 92846 36553
                  </a>
                </li>
                <li>
                  <a href="mailto:contact@gawkari.com" className="text-white text-decoration-none d-flex align-items-center gap-2">
                    <svg xmlns="http://www.w3.org/2000/svg" className="icon icon-tabler icon-tabler-mail" width="20" height="20" viewBox="0 0 24 24" strokeWidth="2" stroke="currentColor" fill="none" strokeLinecap="round" strokeLinejoin="round"><path stroke="none" d="M0 0h24v24H0z" fill="none"/><path d="M3 7a2 2 0 0 1 2 -2h14a2 2 0 0 1 2 2v10a2 2 0 0 1 -2 2H5a2 2 0 0 1 -2 -2V7z" /><path d="M3 7l9 6l9 -6" /></svg>
                    contact@gawkari.com
                  </a>
                </li>
                <li>
                  <a href="https://maps.app.goo.gl/ALuQa8cYfJZUDA9H7" target="_blank" rel="noreferrer" className="text-white text-decoration-none d-flex align-items-center gap-2">
                    <svg xmlns="http://www.w3.org/2000/svg" className="icon icon-tabler icon-tabler-map-pin" width="20" height="20" viewBox="0 0 24 24" strokeWidth="2" stroke="currentColor" fill="none" strokeLinecap="round" strokeLinejoin="round"><path stroke="none" d="M0 0h24v24H0z" fill="none"/><path d="M9 11a3 3 0 1 0 6 0a3 3 0 0 0 -6 0" /><path d="M17.657 16.657l-4.243 4.243a2 2 0 0 1 -2.827 0l-4.244 -4.243a8 8 0 1 1 11.314 0z" /></svg>
                    Navigate to Gawkari Hillside
                  </a>
                </li>
              </ul>

              <div className="mb-4 mb-md-0">
                <h4 className="h4 text-white mb-3">Follow Us</h4>
                <div className="d-flex gap-3">
                  {socialLinks.map((social) => (
                    <a
                      key={social.label}
                      href={social.href}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="text-white"
                      aria-label={`Follow us on ${social.label}`}
                    >
                      {social.icon}
                    </a>
                  ))}
                </div>
              </div>
            </div>
            
            <div className="col-12 col-md-8">
              <div className="row g-4 justify-content-lg-end">
                {footerColumns.map((column) => (
                  <div key={column.title} className="col-6 col-sm-4">
                    <h3 className="h4 text-white mb-3">{column.title}</h3>
                    <ul className="list-unstyled d-flex flex-column gap-2 mb-0">
                      {column.links.map((link) => (
                        <li key={link.label}>
                          {link.external ? (
                            <a
                              href={link.href}
                              target="_blank"
                              rel="noreferrer"
                              className="text-white-75 text-decoration-none hover-white"
                            >
                              {link.label}
                            </a>
                          ) : (
                            <Link to={link.href} className="text-white-75 text-decoration-none hover-white">
                              {link.label}
                            </Link>
                          )}
                        </li>
                      ))}
                    </ul>
                  </div>
                ))}
              </div>
            </div>
          </div>
          
          <div className="border-top border-white-50 mt-5 pt-4">
            <div className="row align-items-center gy-3 text-center text-md-start">
              <div className="col-12 col-md-6 text-white-75">
                © {currentYear} <strong>Gawkari Agro Tourism</strong>. All rights reserved.
              </div>
              <div className="col-12 col-md-6 text-md-end text-white-75">
                Design &amp; development by <a href="https://theaiservicescompany.com" target="_blank" rel="noopener" className="text-white text-decoration-underline" title="The AI Services Company - Web Design & Development">The AI Services Company</a>
              </div>
            </div>
          </div>
        </div>
      </footer>
    </>
  );
}
